/*
  COREEX footer
  1) Link columns collapse into accordions below 741px. Panels are OPEN in the
     markup, and this script opts each column into collapsing by adding
     .is-collapsible — so if the script never runs, every link stays visible
     instead of the footer becoming a row of dead headings.
  2) "You've reached the bottom" scrolls back to the top, honouring
     prefers-reduced-motion.

  The panel height is animated with ONE shared duration for open AND close;
  padding lives on the inner list so it cannot fight the height animation.
*/
(function () {
  'use strict';

  var MOBILE = '(max-width: 740px)';
  var mqMobile = window.matchMedia(MOBILE);
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setupAccordion(footer) {
    var cols = footer.querySelectorAll('.coreex-footer__col');
    var ms = (parseFloat(footer.getAttribute('data-panel-speed')) || 0.3) * 1000;

    function openCol(col, animate) {
      var panel = col.querySelector('.coreex-footer__panel');
      var list = col.querySelector('.coreex-footer__list');
      col.classList.add('is-open');
      setExpanded(col, true);
      if (!panel || !list) return;
      if (!animate || reduced.matches) return;

      if (col.__anim) col.__anim.cancel();
      var to = list.offsetHeight;
      col.__anim = panel.animate([{ height: '0px' }, { height: to + 'px' }], {
        duration: ms,
        easing: 'ease'
      });
      col.__anim.onfinish = function () {
        panel.style.height = '';
        col.__anim = null;
      };
    }

    function closeCol(col, animate) {
      var panel = col.querySelector('.coreex-footer__panel');
      if (!panel) {
        col.classList.remove('is-open');
        setExpanded(col, false);
        return;
      }
      if (!animate || reduced.matches) {
        col.classList.remove('is-open');
        setExpanded(col, false);
        return;
      }

      if (col.__anim) col.__anim.cancel();
      var from = panel.offsetHeight;
      col.__anim = panel.animate([{ height: from + 'px' }, { height: '0px' }], {
        duration: ms,
        easing: 'ease'
      });
      col.__anim.onfinish = function () {
        col.classList.remove('is-open');
        setExpanded(col, false);
        panel.style.height = '';
        col.__anim = null;
      };
    }

    function setExpanded(col, isOpen) {
      var btn = col.querySelector('.coreex-footer__col-toggle');
      if (btn) btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    function enable() {
      for (var i = 0; i < cols.length; i++) {
        var col = cols[i];
        col.classList.add('is-collapsible');
        if (col.getAttribute('data-open-default') === 'true') {
          col.classList.add('is-open');
          setExpanded(col, true);
        } else {
          col.classList.remove('is-open');
          setExpanded(col, false);
        }
      }
    }

    function disable() {
      for (var i = 0; i < cols.length; i++) {
        var col = cols[i];
        if (col.__anim) col.__anim.cancel();
        col.classList.remove('is-collapsible');
        col.classList.remove('is-open');
        var panel = col.querySelector('.coreex-footer__panel');
        if (panel) panel.style.height = '';
        var btn = col.querySelector('.coreex-footer__col-toggle');
        if (btn) btn.removeAttribute('aria-expanded');
      }
    }

    function sync() {
      if (mqMobile.matches) enable();
      else disable();
    }

    for (var i = 0; i < cols.length; i++) {
      (function (col) {
        var btn = col.querySelector('.coreex-footer__col-toggle');
        if (!btn) return;
        btn.addEventListener('click', function () {
          // desktop columns are not collapsible, so the click is a no-op there
          if (!col.classList.contains('is-collapsible')) return;
          if (col.classList.contains('is-open')) closeCol(col, true);
          else openCol(col, true);
        });
      })(cols[i]);
    }

    sync();
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', sync);
    else if (mqMobile.addListener) mqMobile.addListener(sync); // older Safari
  }

  function setupToTop(footer) {
    var btn = footer.querySelector('.coreex-footer__totop');
    if (!btn) return;
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduced.matches ? 'auto' : 'smooth' });
    });
  }

  function initSection(footer) {
    if (!footer || footer.__cfInit) return;
    footer.__cfInit = true;
    setupAccordion(footer);
    setupToTop(footer);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.coreex-footer');
    for (var i = 0; i < nodes.length; i++) initSection(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.coreex-footer');
    if (r) {
      r.__cfInit = false;
      initSection(r);
    }
  });
})();
